import { Dialog, Notify } from 'quasar';

import CustomerAccessDialog from '@/components/dialogs/CustomerAccessDialog.vue';
import { Constants } from '@/constants';
import { currentLocale, i18n } from '@/plugins/i18n';

// The API refused the entry: the community is a customer's and no grant runs.
export const isCustomerAccessRequired = (error: unknown) =>
  (error as { response?: { data?: { code?: string } } })?.response?.data?.code ===
  Constants.CustomerAccess.ReferenceRequiredCode;

// Resolves with the reference of the customer's request, or null when the
// superadmin gives up entering.
export const askCustomerAccessReference = (communityName: string): Promise<string | null> =>
  new Promise((resolve) => {
    Dialog.create({ component: CustomerAccessDialog, componentProps: { communityName } })
      .onOk((reference: string) => resolve(reference))
      .onCancel(() => resolve(null));
  });

export const formatAccessUntil = (until: string) =>
  new Date(until).toLocaleTimeString(currentLocale(), { hour: '2-digit', minute: '2-digit' });

// The last community was a customer's whose access has run out, so the admin
// opened elsewhere; the superadmin can go back by giving a reference again.
export const notifyCustomerAccessEnded = (communityName: string, reopen: () => void) => {
  Notify.create({
    type: 'info',
    message: i18n.global.t('customerAccess.ended', { community: communityName }),
    timeout: 10000,
    actions: [{ label: i18n.global.t('customerAccess.reopen'), color: 'white', handler: reopen }],
  });
};
